import CryptoJS from 'crypto-js'
import { useClipboard } from '@vueuse/core'

const prodSecretKey = import.meta.env.VITE_LOGIN_AES_KEY
const testSecretKey = 'O2rfvFdo46F6fogJhQ3xyoP9A4Fwagu4'
const key = import.meta.env.MODE === 'production' ? prodSecretKey : testSecretKey
// 生成一个 256 位的密钥
const SECRET_KEY = CryptoJS.enc.Utf8.parse(key)

export const shortAddress = (address: string) => {
  if (!address) return ''
  const len = address.length
  return `${address.slice(0, 5)}...${address.slice(len - 4, len)}`
}

export const isAddress = (address: string) => {
  const pattern = /^0x[a-fA-F0-9]{40}$/
  return pattern.test(address)
}

/**
 * @decs 价格格式处理  1,000,000
 * @returns
 */
export function priceFormat(num: number | string, digit = 2) {
  if (!num) return 0

  // 将数字格式化为带有指定小数位的字符串
  const [integerPart, decimalPart] = Number(num).toFixed(digit).toString().split('.')

  // 去除小数部分末尾的多余0
  const cleanedDecimalPart = decimalPart?.replace(/0+$/, '')

  // 如果 cleanedDecimalPart 为空，表示没有小数部分
  const formattedPrice = cleanedDecimalPart
    ? `${integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}.${cleanedDecimalPart}`
    : `${integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`

  return formattedPrice
}

export const copyInfo = (text: string) => {
  const source = ref(text)
  const { copy } = useClipboard({ source, legacy: true })
  copy()
}

export const setImgUrl = (src: string) => {
  return new URL(src, import.meta.url).href
}
/**
 *
 * 处理图片url 后缀
 */
export const webpImageHandle = (url: string, type = 2) => {
  // 处理空值
  if (url === null || url.length === 0) {
    return url
  }

  const TYPE = {
    1: '@style@webp', // 无宽限制
    2: '@style@cover', // 限宽
  } as { [key: number]: string }
  const GIF_TYPE = {
    // 1: '@style@gif',
    // 2: '@style@gifcover',
    // gif暂时先不缩图，因为有大于10m的情况，目前金山云就能处理10m
    1: '',
    2: '',
  } as { [key: number]: string }
  const isGif = !!url.toUpperCase().includes('.GIF')
  if (url.includes('image.slash.sg')) {
    return url + (isGif ? GIF_TYPE[type] : TYPE[type])
  } else {
    return url
  }
}
/**
 * @decs 处理富文本中 图片地址
 * @param 富文本内容
 */
export const replaceImg = (content: any) => {
  if (!content) return
  const imgObj = /<img [^>]*src=['"]([^'"]+)[^>]*>/g
  const imgArr = content.match(imgObj)
  if (imgArr) {
    for (let i = 0; i < imgArr.length; i++) {
      const srcImg = imgArr[i].replace(imgObj, '$1')
      if (srcImg.includes('image.slash.sg')) {
        const newItem = imgArr[i].replace(
          /src=['"]([^'"]+)[^>]*>/gi,
          `src="${webpImageHandle(srcImg)}"` + '>',
        )
        content = content.replace(imgArr[i], newItem)
      }
    }
  }

  return content
}

export function getAudioDuration(src: string): Promise<string> {
  return new Promise((resolve, reject) => {
    const au: HTMLAudioElement = document.createElement('audio')
    au.src = src
    au.addEventListener(
      'loadedmetadata',
      () => {
        resolve(au.duration)
      },
      false,
    )

    au.addEventListener('error', e => {
      reject(e)
    })
  })
}

export function sleep(ms: number): Promise<void> {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve()
    }, ms)
  })
}

export function isMobile(): boolean {
  const { isTelegram } = useTelegram()
  if (
    isTelegram ||
    window.navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i,
    )
  ) {
    return true // 移动端
  } else {
    return false // PC端
  }
}

/**
 * 先判断是模糊图还是清晰图（模糊图有规律，url路径中带了/b/这样的。例如 https://image.dfans.xyz/b/12345678887.webp）
 * 如果是模糊图，直接显示（已经压缩过了）
 * 如果是清晰图，那么在首页等小界面（nft封面，post封面，图片墙封面）等用缩略图，规则是
 * 在图片Url地址父目录替换（换/w/或者/a/为/t/就是缩略图）。 例如： 大图为https://image.dfans.xyz/w/12345.webp, 则缩略图地址为： https://image.dfans.xyz/t/12345.webp
 * 需要高清图片的地方，如合约背景图，点击放大的原图，直接用清晰图的原本的url
 * @param src 图片url
 * @param type 缩略: thumbnails 原图: original
 */
const BIG_PATTERN = /\/[war]\//i
const THUMB_PATTERN = /\/t\//i
export const imgUrlHandel = (src: string, type: string) => {
  if (type === 'default') {
    return src
  }
  if (src?.includes('image.dfans.xyz')) {
    if (BIG_PATTERN.test(src) && type === 'thumbnails') {
      // 原图替换为 缩略图
      return src.replace(BIG_PATTERN, '/t/')
    } else if (THUMB_PATTERN.test(src) && type === 'original') {
      return src.replace(THUMB_PATTERN, '/w/') // 这里感觉有可能有换到/a/的情况先看看观察一下
    } else {
      return src
    }
  } else {
    return src
  }
}

export const isWaterMark = (src: string) => {
  return src.includes('\/w\/')
  // if (src?.includes('image.dfans.xyz')) {
  //   return false
  // }
  // else {
  //   return src.includes('\/w\/')
  // }
}

export const downloadImg = (src: string, fileName: string) => {
  const x = new XMLHttpRequest()
  x.open('GET', src, true)
  x.responseType = 'blob'
  x.onload = function (e) {
    const url = window.URL.createObjectURL(x.response)
    const a = document.createElement('a')
    a.href = url
    a.target = '_blank'
    a.download = fileName
    a.click()
    a.remove()
  }
  x.send()
}

// 消息中链接处理
export const formatText = (text: string) => {
  const reg = /(https?:\/\/[\w\-.]+(:\d+)?(\/[\w\-_.]*)*(\?[\w=&-]*)?)/g
  const nextText = text
    .trim()
    .replace(/(https?:\/\/[\w\-.]+(:\d+)?)/g, ' $1')
    .replace(
      reg,
      '<a class="break-all underline cursor-pointer" style="color: #00aff0;" target="_blank" href=\'$1\'>$1</a>',
    )
    .replace(/\n/g, '<br />')
  return nextText
}

/**
 * 评论中的链接处理
 * 只处理 https://dfans.xyz/xxxx 的内容 为 a 链接
 */
export const formatCommentText = (text: string) => {
  // 检查是否以 'https://dfans.xyz' 开头
  if (text?.startsWith('https://dfans.xyz')) {
    const reg = /(https?:\/\/[\w\-.]+(:\d+)?(\/[\w\-_.]*)*(\?[\w=&-]*)?)/g
    const nextText = text
      .trim()
      .replace(/(https?:\/\/[\w\-.]+(:\d+)?)/g, ' $1')
      .replace(
        reg,
        '<a class="break-all underline cursor-pointer" style="color: #00aff0;" target="_blank" href=\'$1\'>$1</a>',
      )
      .replace(/\n/g, '<br />')
    return nextText
  }

  // 如果不是以 'https://dfans.xyz' 开头，直接返回原文本
  return text
}

// 加密函数
export const encryptData = (originalData: string) => {
  // 使用AES-256加密
  const encrypted = CryptoJS.AES.encrypt(originalData, SECRET_KEY, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  })
  return encrypted.toString()
}

// 解密函数
export const decryptAES = (encryptedData: string) => {
  // 使用AES-256解密
  const decrypted = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  })
  return CryptoJS.enc.Utf8.stringify(decrypted)
}

export const successTheme = () => {
  return {
    '--input-input-font-size': '16px',
    '--field-decorator-text-color': isDark.value ? '#fff' : '#242529',
    '--field-decorator-blur-color': isDark.value ? 'rgba(138, 150, 163, 0.5)' : '#C4CAD1',
    '--field-decorator-line-focus-size': '1px',
    '--field-decorator-focus-color': isDark.value ? '#F6F7F8' : '#666666',
    '--field-decorator-placeholder-color': '#8A96A3',
    '--field-decorator-error-color': '#FF6060',
    '--form-details-error-message-color': '#FF6060',
    '--field-decorator-disabled-color': '#8A96A3',
    '--field-decorator-line-border-radius': '8px',
    '--field-decorator-outlined-normal-margin-top': '0px',
    '--field-decorator-outlined-normal-margin-bottom': '0px',
    '--field-decorator-outlined-normal-icon-margin-top': '0px',
    '--field-decorator-outlined-normal-icon-margin-bottom': '0px',
    '--form-details-margin-top': '0px',
  }
}
